export default __webpack_public_path__ + "static/media/privacy_policy.1bd0113d.pdf";